import React, { useState, useEffect } from 'react';
import { format, isValid, parseISO } from 'date-fns';
import FluentModal from './FluentModal';
import { BasicHeader } from '../../actions/BasicHeader';
import { Button, PrimaryButton } from '../connectedForm/Button';
import { ModalBottomButtonContainer } from './Styles';
import DateField from '../connectedForm/DateInput/DateInput';

interface PostStockTakeModalProps {
  isOpen: boolean;
  onConfirm: (postingDate: Date) => void;
  onCancel: () => void;
  disabled?: boolean;
}

const PostStockTakeModal: React.FC<PostStockTakeModalProps> = ({ isOpen, onConfirm, onCancel, disabled }) => {
  const [selectedDate, setSelectedDate] = useState<string>(format(new Date(), 'yyyy-MM-dd'));

  useEffect(() => {
    if (isOpen) {
      setSelectedDate(format(new Date(), 'yyyy-MM-dd'));
    }
  }, [isOpen]);

  const handleConfirm = () => {
    const parsedDate = parseISO(selectedDate);
    if (!isValid(parsedDate)) {
      // Reset to today if the entered value is invalid, and do not post
      const today = new Date();
      setSelectedDate(format(today, 'yyyy-MM-dd'));
      return;
    }

    onConfirm(parsedDate);
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <FluentModal isOpen={isOpen} styles={{ main: { paddingBottom: '60px', minWidth: '500px' } }}>
      <BasicHeader>Post Stock Take</BasicHeader>
      <div style={{ padding: '1em' }}>
        <p>Choose a posting date for this stock take.</p>
        <DateField
          data-testid="post-stock-take-posting-date"
          label="Posting Date"
          value={selectedDate}
          onChange={setSelectedDate}
          portal={true}
          mandatory={true}
          isClearable={false}
          validatePostingDate={true}
          maxDate={new Date()}
        />
      </div>
      <ModalBottomButtonContainer>
        <Button onClick={handleCancel} data-testid="post-stock-take-cancel">
          Cancel
        </Button>
        <PrimaryButton onClick={handleConfirm} disabled={disabled} data-testid="post-stock-take-confirm">
          Post
        </PrimaryButton>
      </ModalBottomButtonContainer>
    </FluentModal>
  );
};

export default PostStockTakeModal;
